/**
 * UnifiedAppShellHeader Component - Row 1 (Global Header)
 *
 * DEPRECATED: This component now returns null.
 * Cache controls moved to AppShell's MobileSidebar and TopBar.
 *
 * Previously displayed:
 * - CacheStatus (last refresh time, record counts)
 * - SyncButton
 *
 * Kept for backward compatibility with existing view imports.
 */

import React from 'react';

export interface UnifiedAppShellHeaderProps {
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * Unified Row 1 Header - DEPRECATED (returns null)
 *
 * @example
 * ```tsx
 * <UnifiedAppShellHeader />
 * ```
 */
export const UnifiedAppShellHeader: React.FC<UnifiedAppShellHeaderProps> = ({
  className = '',
}) => {
  // Removed: Cache status bar no longer shown between breadcrumb and page content
  // CacheStatus and SyncButton are still available in AppShell's MobileSidebar
  return null;
};
